import dtBreadcrumb from "./index.vue";

dtBreadcrumb.install = function (Vue) {
    Vue.component(dtBreadcrumb.name, dtBreadcrumb);
};

export default dtBreadcrumb;